export function exportToDXF(layout: any): string {
    if (!layout?.floor_plan_geojson?.categories) return '';

    let dxf = `0\nSECTION\n2\nENTITIES\n`;

    const addLwPolyline = (points: number[][], layer: string, isClosed: boolean = true) => {
        dxf += `0\nLWPOLYLINE\n8\n${layer}\n90\n${points.length}\n70\n${isClosed ? 1 : 0}\n`;
        for (const pt of points) {
            dxf += `10\n${pt[0].toFixed(4)}\n20\n${-pt[1].toFixed(4)}\n`; // Invert Y for standard CAD interpretation
        }
    };

    const processGeometry = (geom: any, layer: string) => {
        if (!geom) return;
        if (geom.type === 'Polygon') {
            geom.coordinates.forEach((ring: number[][]) => addLwPolyline(ring, layer, true));
        } else if (geom.type === 'MultiPolygon') {
            geom.coordinates.forEach((poly: any) => {
                poly.forEach((ring: number[][]) => addLwPolyline(ring, layer, true));
            });
        }
    };

    const geojson = layout.floor_plan_geojson;

    // Draw all categories
    for (const [cat, geom] of Object.entries(geojson.categories)) {
        processGeometry(geom, cat.toUpperCase());
    }

    // Draw inner boundary if exists
    if (geojson.inner) {
        processGeometry(geojson.inner, 'INNER_BOUNDARY');
    }

    dxf += `0\nENDSEC\n0\nEOF\n`;
    return dxf;
}

export function downloadDXF(layout: any) {
    const dxfString = exportToDXF(layout);
    if (!dxfString) return;
    const blob = new Blob([dxfString], { type: 'application/dxf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `layout_${layout.id || 'export'}.dxf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
